<p>{{'sponsorsTitle' | transloco}}</p>
<div class="logos">
  <a href="https://ng-conf.org" target="_blank">
    <img
      class="ngconf"
      src="./assets/images/ngconf_logo.png"
      alt="ng conf logo"
    />
  </a>

  <a href="https://limblecmms.com/" target="_blank">
    <img
      _ngcontent-dnb-c102=""
      src="./assets/images/limblecmms_logo.png"
      alt="Limble logo"
      class="limble"
    />
  </a>

<!--  <a href="https://www.thisdot.co/" target="_blank">-->
<!--    <img-->
<!--      _ngcontent-dnb-c102=""-->
<!--      src="./assets/images/thisdotlabs_logo.png"-->
<!--      alt="ThisDotLabs"-->
<!--      class="thisdotlabs"-->
<!--      />-->
<!--  </a>-->
</div>

<div class="logos">
<!--  <a href="https://oasisdigital.com/" target="_blank">-->
<!--    <img-->
<!--      _ngcontent-dnb-c102=""-->
<!--      src="./assets/images/od-logo-2x1.png"-->
<!--      alt="progress logo"-->
<!--      class="oasis"-->
<!--    />-->
<!--  </a>-->
<!--  <a href="https://www.cypress.io/" target="_blank">-->
<!--    <img-->
<!--      _ngcontent-dnb-c102=""-->
<!--      src="./assets/images/Cypress_Logotype_Color_Light_BG.png"-->
<!--      alt="Cypress logo"-->
<!--      class="cypress"-->
<!--    />-->
<!--  </a>-->

<!--  <a href="https://open.spotify.com/show/1PrLErQHBqBhZsRV1KHhGM" target="_blank">-->
<!--    <img-->
<!--      _ngcontent-dnb-c102=""-->
<!--      src="./assets/images/devlife_logo.png"-->
<!--      alt="devlife logo"-->
<!--      class="devlife"-->
<!--    />-->
<!--  </a>-->
</div>
<div class="logos">


<!--  <a href="https://stgconsulting.com/" target="_blank">-->
<!--    <img-->
<!--      _ngcontent-dnb-c102=""-->
<!--      src="./assets/images/STG_ICON_HighRes.png"-->
<!--      alt="STGConsulting"-->
<!--      class="STG"-->
<!--      />-->
<!--  </a>-->

<!--  <a href="https://stgconsulting.com/" target="_blank">-->
<!--    <img-->
<!--      _ngcontent-dnb-c102=""-->
<!--      src="./assets/images/jetbrains_logo.png"-->
<!--      alt="JetBrains"-->
<!--      class="jetbrains"-->
<!--      />-->
<!--  </a>-->
</div>


